import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImport, DBImportType } from '../../types/import';
import { EndpointResponse } from '../../types/endpoints';
import type { ApiQueryParams } from '../../types/apiQuery';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

const validate = (importType: string) => {
  if (!importType) {
    throw new Error('`importType` is required');
  }
};

type RequestParams = Pick<ApiQueryParams, 'limit' | 'page'> & {
  importType: DBImportType;
};

type Response = DBImport[];

export const getImports = async (
  scope: RequestScope,
  { importType, limit = 1000, page = 1 }: RequestParams,
  requestOptions: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(importType);

    const result = await scopedApi(scope).get<EndpointResponse<Response>>(
      `${importType}/import?sort=created_at:-1&limit=${limit}&page=${page}`,
      requestOptions
    );

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
